"use client";

import Image from "next/image";
import { cn } from "@/lib/cn";
import type { SystemScreen } from "@/data/system-screens";

interface SystemWindowProps {
  screens: SystemScreen[];
  active: number;
  sizes: string;
  priority?: boolean;
  className?: string;
}

/**
 * Janela de aplicativo (barra com 3 pontos, borda em degradê e brilho) que exibe
 * as telas do sistema. As telas ficam empilhadas e trocam com fade.
 */
export default function SystemWindow({
  screens,
  active,
  sizes,
  priority = false,
  className,
}: SystemWindowProps) {
  const current = screens[active] ?? screens[0];
  return (
    <div className={cn("relative", className)}>
      <div className="rounded-[22px] bg-gradient-to-b from-electric/60 via-violet/25 to-line/10 p-px shadow-[0_40px_120px_-40px_rgb(var(--brand)_/_0.6)]">
        <div className="overflow-hidden rounded-[21px] bg-[#0b1220]">
          <div className="flex h-9 items-center gap-1.5 border-b border-white/5 bg-[#0e1626] px-4">
            <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
            <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
            <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
            <span className="ml-3 truncate text-[11px] font-medium text-muted">
              Alert AI · {current.label}
            </span>
          </div>

          <div className="relative aspect-[1.9/1] bg-[#0b1220]">
            {screens.map((s, i) => (
              <Image
                key={s.id}
                src={s.image}
                alt={s.alt}
                fill
                sizes={sizes}
                priority={priority && i === 0}
                aria-hidden={i !== active}
                className={cn(
                  "object-contain object-left-top transition-[opacity,transform] duration-700 ease-out motion-reduce:transition-none",
                  i === active ? "scale-100 opacity-100" : "scale-[1.015] opacity-0"
                )}
              />
            ))}
            {/* esmaece a borda inferior (telas com proporções diferentes) */}
            <div
              aria-hidden="true"
              className="pointer-events-none absolute inset-x-0 bottom-0 h-[12%] bg-gradient-to-t from-[#0b1220] to-transparent"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
